var map = {
	"./404.vue": "8cdb",
	"./bigScreen/bigScreen.vue": "8fcb",
	"./graphics/view.vue": "40c3",
	"./index.vue": "1e4b",
	"./reader/IdentityReader.vue": "27e9",
	"./test/test.vue": "1a83",
	"./user/info.vue": "1d46",
	"./user/login.vue": "71a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "71bc";